import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getAppointmentAnalyses = asyncThunkWrapper({ 
  model: 'appointmentAnalyses', 
  action: 'getAppointmentAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'input', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/appointment_flow/appointment_analyses', { params });

    return response.data;
  } 
});
export const getAppointmentAnalysis = asyncThunkWrapper({ 
  model: 'appointmentAnalyses', 
  action: 'getAppointmentAnalysis', 
  func: async ({ id, cable = false },) => {
    const attributes = ['id', 'input', 'result', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/appointment_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const clearLocalAppointmentAnalyses = createAction('appointmentAnalyses/clearLocalAppointmentAnalyses');
export const clearLocalActiveAppointmentAnalysis = createAction('appointmentAnalyses/clearLocalActiveAppointmentAnalysis');